import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Fields, reduxForm } from 'redux-form';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Button, Col, Row, FormLabel } from 'react-bootstrap';
import { connect } from 'react-redux';
import { scrollToFirstError, generateValidation, TextInput } from 'ecs-react-components/dist/index.es';
import history from '../../history';
import validations from './LoginForm.validations';
import { messages } from './LoginForm.i18n';
import Header from '../../components/Header/Header';
import LanguageSelectionDropdown from '../../containers/LanguageSelectionDropdown/LanguageSelectionDropdown';

import * as MsgBarActions from '../../redux/modules/system-shared/message-bar-action-creator';

export const fields = ['username', 'password'];

class LoginForm extends Component {
  onSubmit = (values) => {
    this.props.handleLogin(values);
  };

  onFormChange = () => {
    this.props.dispatch(MsgBarActions.dismissMessage());
  };

  onForgotPasswordClick = (event) => {
    event.preventDefault();
    this.props.handleForgotPassword();
  }

  onCreateNewAccountClick = () => {
    history.push('/sign-up');
  }

  renderRequired(field) {
    return (
        <div className="invalid-feedback" data-qa-item={'req_' + field.input.name}>
          <FormattedMessage {...messages.required.error} />
        </div>
    );
  }

  renderLabel(field, messageFormatId, formatMessage) {
    return (
      <FormLabel htmlFor={field.input.name}>
        { formatMessage(messageFormatId) }
      </FormLabel>
    );
  }

  renderTextInput(field, type) {
    let userErrorHints = null;
    if (field.meta.invalid && !field.input.value.length) {
      userErrorHints = this.renderRequired(field);
    }
    return (
      <div>
        <TextInput
          field={ field }
          type={type}
        />
        { userErrorHints }
      </div>
    );
  }

  renderInputElements(field, type, messageFormId, formatMessage) {
    return (
      <div className="form-group">
        {this.renderLabel(field, messageFormId, formatMessage)}
        {this.renderTextInput(field, type)}
      </div>
    );
  }

  renderFields = (fieldsMeta) => {
    const { formatMessage } = this.props.intl;
    const {
      username,
      password,
    } = fieldsMeta;

    return (
      <div>
      <div className="mb-3">
        {this.renderInputElements(
          username,
          'text',
          messages.usernameTitle.label,
          formatMessage)}
      </div>
      <div className="mb-3">
        {this.renderInputElements(
          password,
          'password',
          messages.passwordTitle.label,
          formatMessage)}
      </div>
      </div>
    );
  }

  render() {
    const { handleSubmit } = this.props;
    const pageTitle =
      this.props.intl.formatMessage(messages.page.title, { facilityPortalName: this.props.facilityPortalName });

    return (
      <div className="row page-layout-view">
        <Row>
          <div className="clearfix">
          <Col>
              <LanguageSelectionDropdown />
          </Col>
          <Col>
              <Header
                headerTitle={pageTitle}
              />
          </Col>
          </div>
          <Col>
          <div className="LoginForm card-group">
            <div className="card p-4">
              <div className="card-body">
                <h5 tabIndex="0" className="card-title mb-3">
                  <FormattedMessage {...messages.login.label} />
                </h5>
                  <form onSubmit={handleSubmit(this.onSubmit)}
                    onChange={this.onFormChange}
                  >
                    <Fields names={fields} component={this.renderFields} />
                    <div className="button-area">
                      <Button className="mr-1" type="submit" aria-describedby="button_description">
                        <FormattedMessage {...messages.login.label} />
                      </Button>
                      <a type="button" className="btn btn-link pull-right"
                        onClick={this.onForgotPasswordClick} href="#"
                        aria-describedby="button_description"
                      >
                        <FormattedMessage {...messages.forgotPassword.label} />
                      </a>
                    </div>
                  </form>
              </div>
            </div>
            <div className="card p-4">
              <div className="card-body">
                <h5 className="card-title mb-3" tabIndex="0" aria-describedby="content_description">
                  <FormattedMessage {...messages.signup.label} />
                </h5>
                <div className="card-text" id="content_description">
                  <p><FormattedMessage {...messages.signup.description} /></p>
                </div>
                <div className="button-area">
                  <Button className="btn btn-primary" href="#" role="button"
                    aria-describedby="button_description"
                    onClick={this.onCreateNewAccountClick}
                  >
                    <FormattedMessage {...messages.signup.button.createAccount} />
                  </Button>
                </div>
              </div>
            </div>
          </div>
          </Col>
        </Row>
        <span id="button_description" className="sr-only">
          <FormattedMessage {...messages.signup.button.description} />
        </span>
      </div>
    );
  }
}

LoginForm.propTypes = {
  handleSubmit: PropTypes.func,
  handleLogin: PropTypes.func.isRequired,
  handleForgotPassword: PropTypes.func.isRequired,
  intl: PropTypes.object,
  errorMessage: PropTypes.string,
  facilityPortalName: PropTypes.string,
  error: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  submitFailed: PropTypes.bool,
  dispatch: PropTypes.func,
};

const reduxFormConfig = {
  form: 'loginform',
  enableReinitialize: true,
  onSubmitFail: (errors) => scrollToFirstError(errors, fields),
  fields,
  ...generateValidation(validations),
};

const mapStateToProps = (state) => ({
  facilityPortalName: state.facility ? state.facility.facilityPortalName : null,
});


export default reduxForm(reduxFormConfig)(connect(mapStateToProps)(injectIntl(LoginForm)));
